module.exports = __webpack_public_path__ + "img/neutral.f95e3f89.svg";